module.exports = __webpack_public_path__ + "static/img/75-3.0a78d71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/75-3.jpg
// module id = /Jt6
// module chunks = 0